export const getBaseUrl = () => {
  const { hostname } = window.location;

  if (hostname === "localhost") {
    return "http://localhost:5300/api";
  }

  // If using visiblecampus legacy admin
  if (hostname.endsWith("visiblecampus.com")) {
    return "https://api.admin.visiblecampus.com/api";
  }

  // Default SaaS API — all subdomains and custom domains hit the same API
  // Custom domains (e.g. lms.abcinstitute.com) also route to api.lmscampus.com
  // because CNAME resolves to lmscampus.com infra. The Origin header carries
  // the custom domain for tenant resolution on the backend.
  return "https://api.lmscampus.com/api";
};

/**
 * Detect whether the current hostname represents an institute portal
 * (subdomain like abc.lmscampus.com OR custom domain like lms.abc.com)
 * vs the main platform (lms.lmscampus.com) or localhost.
 */
export const isInstitutePortal = () => {
  const hostname = window.location.hostname;
  if (hostname === "localhost") return false;

  // lmscampus.com subdomains
  if (hostname.endsWith(".lmscampus.com")) {
    const mainHosts = ["lmscampus.com", "www.lmscampus.com", "lms.lmscampus.com", "app.lmscampus.com", "api.lmscampus.com"];
    return !mainHosts.includes(hostname);
  }

  // visiblecampus legacy
  if (hostname.endsWith("visiblecampus.com")) return false;

  // Any other domain with a dot = custom domain (lms.abcinstitute.com)
  if (hostname.includes(".")) return true;

  return false;
};